import SearchPreview from "./search-preview";
export default SearchPreview
